export default __webpack_public_path__ + "static/brick-texture-9a022f9490ee5433b4c0ee715c9aaaf2.jpg";